// extracted by mini-css-extract-plugin
export default {"md":"Markdown_md__vuq4m"};